import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { UpdateUserTracking } from "../../slices/trackingSlice"
import { getAllUrlParams, removeNullKeys } from "../../common/utils"
import * as Sentry from "@sentry/browser"

const Tracking = ({ children }) => {
  const dispatch = useDispatch()
  const trackingState = useSelector(state => state.tracking)
  const [storageSet, setStorageSet] = useState(false)

  const { data, userUnauthed } = useSelector(state => state.user)

  const params =
    typeof window !== "undefined" && getAllUrlParams(window.location.href)

  const prefix = "boatlink-tracking"

  //on load check url query and set local storage
  useEffect(() => {
    try {
      let storageChange = false
      Object.entries(params).forEach(([key, value]) => {
        storageChange = true
        window.localStorage.setItem(`${prefix}-${key}`, value)
      })

      if (
        typeof document !== `undefined` &&
        document.referrer?.length &&
        !document.referrer?.includes("theboatlink.com") &&
        !document.referrer?.includes("localhost")
      ) {
        storageChange = true
        localStorage.setItem(`${prefix}-referrer`, document.referrer)
      }
      if (storageChange) {
        setStorageSet(true)
      }
    } catch (err) {
      debugger
      Sentry.captureException(err)
    }
  }, [])

  //compare items in local storage and in redux and update them if they changed
  useEffect(() => {
    try {
      if (trackingState?.status === "ready" && !userUnauthed && data?.id) {
        let change = false
        const nextTracking = { ...trackingState }

        const items = [
          ...Object.keys(window.localStorage)
            .filter(item => item.includes(prefix))
            .map(item => item.replace(prefix + "-", "")),
          `referrer`,
        ]

        items.forEach(item => {
          const trackingItem = window.localStorage.getItem(`${prefix}-${item}`)
          if (
            item === `referrer` &&
            (trackingItem?.includes("theboatlink.com") ||
              trackingItem?.includes("localhost"))
          )
            return

          if (
            !trackingState[item] ||
            (trackingState[item] !== trackingItem && trackingItem !== null)
          ) {
            change = true
            nextTracking[item] = trackingItem
          }
        })

        if (change) {
          const cleanNextTracking = removeNullKeys(nextTracking)
          if (cleanNextTracking.status) {
            delete cleanNextTracking.status
          }
          dispatch(
            UpdateUserTracking({
              tracking: cleanNextTracking,
              id: data.id,
            })
          )
        }
      } else {
        // return
        //user profile not loaded yet
      }
    } catch (err) {
      Sentry.captureException(err)
    }
  }, [trackingState, userUnauthed, storageSet, trackingState?.status, data?.id])

  return (
    <div>
      {children}
      {/*<button*/}
      {/*  onClick={() =>*/}
      {/*    dispatch(*/}
      {/*      UpdateUserTracking({*/}
      {/*        tracking: { referrer: "google2.com" },*/}
      {/*        id: sub,*/}
      {/*      })*/}
      {/*    )*/}
      {/*  }*/}
      {/*>*/}
      {/*  Test123*/}
      {/*</button>*/}
    </div>
  )
}

export default Tracking
